<ngx-spinner
  bdColor="rgba(37, 55, 87, 0.8)"
  size="medium"
  color="#048ea0"
  type="ball-scale-multiple"
  [fullScreen]="true">
</ngx-spinner>
<router-outlet />
